// Encode and decode functions from https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
function b64EncodeUnicode(str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1);
    }));
}

function b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}
// https://www.ietf.org/rfc/rfc4122.txt
// http://stackoverflow.com/a/2117523
function generateUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random()*16|0, v = c === 'x' ? r : ((r&0x3)|0x8);
        return v.toString(16);
    });
}
class SessionStorageSS {
    constructor() {
        this.set = function (a, b) {

            if (typeof (Storage) !== "undefined") {
                return sessionStorage.setItem(a, JSON.stringify(b));
            }
            else {
                return 'NO STORAGE';
            }
        };
        this.getUuid = function (){
            if (typeof (Storage) !== "undefined") {
                let value = sessionStorage.getItem('unique-id');

                if(!value || !window.name) {
                    value = generateUuid();
                    sessionStorage.setItem('unique-id', value);
                }

                window.name = value;
                return value;
            }
            else {
                return 'NO STORAGE';
            }
        }
        this.get = function (a) {
            if (typeof (Storage) !== "undefined") {
                if(sessionStorage.getItem(a)){
                    return JSON.parse(sessionStorage.getItem(a));
                }else{
                    return 'NO STORAGE';
                }
                
            }
            else {
                return 'NO STORAGE';
            }
        };
        this.setE = function (a, b) {
            
            if (typeof (Storage) !== "undefined") {
                return sessionStorage.setItem(a, b64EncodeUnicode(JSON.stringify(b)));
            }
            else {
                return 'NO STORAGE';
            }
        };
        this.getE = function (a) {
            if (typeof (Storage) !== "undefined") {
                return JSON.parse(b64DecodeUnicode(sessionStorage.getItem(a)));
            }
            else {
                return 'NO STORAGE';
            }
        };

        this.remove = function (a) {
            if (typeof (Storage) !== "undefined") {
                return sessionStorage.removeItem(a);
            }
            else {
                return 'NO STORAGE';
            }
        };
        return this;
    }
}
const SS = new SessionStorageSS();
export default SS;
